<div class="create-shell mt-5">
  <section class="create-acfs">
    <div class="acfs-copy">
      <h1>{{ isEdit() ? 'แก้ไขรายการ' : 'บันทึกการขาย' }}</h1>
      @if (!isEdit()) {
        @if (step() === 0) {
          <p>เลือกธุรกิจที่จะบันทึกการขาย</p>
        } @else if (step() === 1) {
          <p>เลือกสินค้าที่ขาย หรือกรอกชื่อสินค้าใหม่</p>
        } @else {
          <p>กรอกรายละเอียดการขายที่เลือกด้านล่าง</p>
        }
      } @else {
        <p>แก้ไขรายละเอียดของรายการนี้</p>
      }
    </div>
    <img class="acfs-new-img" src="/assets/images/empty-basket.png" alt="">
  </section>

  @if (loading() || (!isEdit() && !store.businessesLoaded())) {
    <section class="product-list-card product-list-skeleton" aria-busy="true" aria-label="กำลังโหลด">
      <div class="skeleton-label"></div>
      @for (item of [1, 2, 3]; track item) {
        <article class="product-skeleton-row">
          <div class="product-skeleton-head">
            <div class="skeleton-copy">
              <div class="skeleton-line skeleton-title"></div>
              <div class="skeleton-line skeleton-sub"></div>
            </div>
            <div class="skeleton-badge"></div>
            <div class="skeleton-icon"></div>
          </div>
        </article>
      }
    </section>
  } @else if (isEdit() && !record()) {
    <section class="state-band">
      <div class="empty-state">
        <strong>ไม่พบรายการนี้</strong>
      </div>
    </section>
  } @else {
    @if (!isEdit()) {
      <div class="step-indicator">
        @if (needsBusinessStep()) {
          <div class="step-pill" [class.active]="step() === 0" [class.done]="step() > 0">
            @if (step() > 0) {
              ✓
            } @else {
              1
            }
          </div>
          <span class="step-label" [class.active]="step() === 0">เลือกธุรกิจ</span>
          <div class="step-connector" [class.filled]="step() > 0"></div>
          <div class="step-pill" [class.active]="step() === 1" [class.done]="step() > 1">
            @if (step() > 1) {
              ✓
            } @else {
              2
            }
          </div>
          <span class="step-label" [class.active]="step() === 1">เลือกสินค้า</span>
          <div class="step-connector" [class.filled]="step() > 1"></div>
          <div class="step-pill" [class.active]="step() === 2">3</div>
          <span class="step-label" [class.active]="step() === 2">รายละเอียด</span>
        } @else {
          <div class="step-pill" [class.active]="step() === 1" [class.done]="step() > 1">
            @if (step() > 1) {
              ✓
            } @else {
              1
            }
          </div>
          <span class="step-label" [class.active]="step() === 1">เลือกสินค้า</span>
          <div class="step-connector" [class.filled]="step() > 1"></div>
          <div class="step-pill" [class.active]="step() === 2">2</div>
          <span class="step-label" [class.active]="step() === 2">รายละเอียด</span>
        }
      </div>
    }

    <!-- step 0: business -->
    @if (!isEdit() && step() === 0) {
      <section class="detail-card">
        <div class="form-section">
          <div class="business-row">
            <app-trade-business-select
              [businesses]="store.businesses()"
              [selectedId]="store.selectedBusinessId()"
              label="เลือกธุรกิจ"
              inputId="trade-harvest-business"
              (selectedIdChange)="onBusinessChange($event)">
            </app-trade-business-select>
            <div>
              <label class="form-label fw-semibold ui-require" for="trade-harvest-business-type">ประเภทธุรกิจ</label>
              <select id="trade-harvest-business-type" class="form-select" name="businessType"
                      [ngModel]="selectedBusinessType()" (ngModelChange)="selectedBusinessType.set($event ?? null)"
                      [disabled]="businessTypeOptions().length === 0">
                <option [ngValue]="null">เลือกประเภทธุรกิจ</option>
                @for (type of businessTypeOptions(); track type) {
                  <option [value]="type">{{ type }}</option>
                }
              </select>
              @if (businessTypeOptions().length === 0 && store.selectedBusinessId() != null) {
                <small class="field-hint">ธุรกิจนี้ยังไม่มีประเภทธุรกิจ —
                  <a routerLink="/profile/business" class="fw-semibold">เพิ่มที่ข้อมูลธุรกิจ</a>
                </small>
              }
            </div>
          </div>
        </div>
        <div class="submit-row">
          <button type="button" class="btn btn-primary w-100"
                  [disabled]="!canContinueFromBusiness" (click)="continueFromBusiness()">
            ถัดไป
          </button>
        </div>
      </section>
    }

    <!-- step 1: product -->
    @if (!isEdit() && step() === 1) {
      @if (needsBusinessStep()) {
        <div class="back-chip-row">
          <button type="button" class="btn btn-default btn-sm" (click)="backToBusiness()">
            <i class="bi bi-arrow-left"></i>
            เปลี่ยนธุรกิจ
          </button>
        </div>
      }
      @if (productsLoading()) {
        <section class="product-list-card product-list-skeleton" aria-busy="true" aria-label="กำลังโหลดสินค้า">
          <div class="skeleton-label"></div>
          @for (item of [1, 2, 3]; track item) {
            <article class="product-skeleton-row">
              <div class="product-skeleton-head">
                <div class="skeleton-copy">
                  <div class="skeleton-line skeleton-title"></div>
                  <div class="skeleton-line skeleton-sub"></div>
                </div>
                <div class="skeleton-badge"></div>
                <div class="skeleton-icon"></div>
              </div>
            </article>
          }
        </section>
      } @else if (products().length > 0) {
        <section class="product-list-card">
          <div class="list-label">สินค้าที่เคยบันทึก</div>
          @for (product of products(); track product.id ?? product.productName) {
            <button type="button" class="product-card" (click)="chooseProduct(product)">
              <span class="row-copy">
                <strong>{{ product.productName }}</strong>
                <small>{{ certificateCountLabel(product) }}</small>
              </span>
              <i class="bi bi-chevron-right row-chevron" aria-hidden="true"></i>
            </button>
          }
        </section>
      }

      <section class="detail-card new-product-card">
        <div class="form-section">
          <div class="section-label">สินค้าใหม่</div>
          @if (!productsLoading() && products().length === 0) {
            <small class="field-hint d-block mb-2">-- ยังไม่มีสินค้าที่เคยบันทึก --</small>
          }
          <div class="harvest-box">
            <label class="harvest-input">
              <span>ชื่อสินค้า</span>
              <input id="trade-new-product" type="text" class="form-control" name="newProductName"
                     list="trade-product-name-list" autocomplete="off" placeholder="เช่น ทุเรียนหมอนทอง"
                     [ngModel]="newProductName()" (ngModelChange)="newProductName.set($event ?? '')">
            </label>
            <datalist id="trade-product-name-list">
              @for (name of productNameSuggestions(); track name) {
                <option [value]="name"></option>
              }
            </datalist>
            <button type="button" class="btn btn-primary w-100"
                    [disabled]="!canUseNewProduct" (click)="chooseNewProduct()">
              ใช้ชื่อนี้
            </button>
          </div>
        </div>
      </section>
    }

    <!-- step 2: details -->
    @if (step() === 2) {
      <section class="detail-card">
        <div class="back-chip-row">
          @if (!isEdit()) {
            <button type="button" class="btn btn-default btn-sm" (click)="backToProduct()">
              <i class="bi bi-arrow-left"></i>
              เปลี่ยนสินค้า
            </button>
          } @else if (record(); as current) {
            <span class="back-hint">แก้ไขรายการ {{ tradeKindLabel(current.kind) }} · {{ current.businessTitle }}</span>
          }
        </div>

        @if (!isEdit() && store.selectedBusiness(); as business) {
          <div class="business-summary" aria-label="ธุรกิจที่บันทึก">
            <i class="bi bi-shop" aria-hidden="true"></i>
            <div>
              <div class="business-summary-title">{{ business.title }}</div>
              <div class="business-summary-meta">
                @if (selectedBusinessType(); as type) {
                  <span class="badge text-bg-light border">{{ type }}</span>
                } @else if (business.businessTypeTitles?.length) {
                  <span class="badge text-bg-light border">{{ business.businessTypeTitles!.join(' · ') }}</span>
                }
                @if (business.taxId) {
                  <span class="text-secondary small">{{ business.taxId }}</span>
                }
              </div>
            </div>
          </div>
        }

        <div class="form-section">
          <div class="section-label">รายละเอียดการขาย</div>
          <div class="harvest-box">
            <label class="harvest-input">
              <span class="ui-require">ชื่อสินค้า</span>
              <input id="trade-product" type="text" class="form-control" [(ngModel)]="form.productName"
                     [disabled]="!canEditQuantity()"
                     [class.is-invalid]="submitted() && !hasProductName" name="productName">
            </label>
            @if (submitted() && !hasProductName) {
              <small class="invalid-feedback d-block text-danger">กรุณาระบุชื่อสินค้า</small>
            }
            @if (!canEditQuantity()) {
              <small class="field-hint">แก้ไขไม่ได้ เพราะมีการขายหรือดึงจากรายการนี้แล้ว</small>
            }
          </div>
          <div class="harvest-box">
            <div class="quantity-unit-row">
              <label class="harvest-input">
                <span class="ui-require">จำนวน</span>
                <input id="trade-quantity" type="text" class="form-control" inputmode="decimal" placeholder="0"
                       [(ngModel)]="form.quantity" (ngModelChange)="onQuantityInput()" name="quantity"
                       [disabled]="!canEditQuantity()"
                       [class.is-invalid]="submitted() && canEditQuantity() && !hasQuantity">
              </label>
              <label class="harvest-input">
                <span>หน่วย</span>
                <input type="text" class="form-control unit-readonly" [value]="unit" readonly tabindex="-1">
              </label>
            </div>
            @if (submitted() && canEditQuantity() && !hasQuantity) {
              <small class="invalid-feedback d-block text-danger">ต้องมากกว่า 0</small>
            }
            @if (!canEditQuantity()) {
              <small class="field-hint">แก้ไขไม่ได้ เพราะมีการขายหรือดึงจากรายการนี้แล้ว</small>
            }
          </div>
          <div class="harvest-box">
            <label class="harvest-input">
              <span [class.ui-require]="!isEdit()">เลือกวันที่เก็บเกี่ยว</span>
              <gt-ng-datepicker id="trade-harvest-date" class="harvest-datepicker" name="harvestDate" inputSize="sm"
                                [(ngModel)]="form.harvestDate"
                                [class.is-invalid]="submitted() && !isEdit() && !hasHarvestDate"></gt-ng-datepicker>
            </label>
            @if (submitted() && !isEdit() && !hasHarvestDate) {
              <small class="invalid-feedback d-block text-danger">กรุณาเลือกวันที่</small>
            }
          </div>
        </div>

        @if (!isEdit() || editKind() === 'HARVEST') {
          <div class="form-section">
            <div class="section-label">ใบรับรอง</div>
            @if (certificatesLoading()) {
              <small class="field-hint">กำลังโหลดใบรับรอง…</small>
            } @else if (businessCertificates().length === 0) {
              <small class="field-hint">ไม่พบใบรับรองของธุรกิจนี้ —
                <a routerLink="/certificate" class="fw-semibold">เพิ่มข้อมูลใบรับรอง</a>
              </small>
            } @else {
              <div class="cert-check-list">
                @for (option of businessCertificates(); track option.key; let index = $index) {
                  <div class="form-check cert-check">
                    <input class="form-check-input" type="checkbox" [id]="'trade-cert-' + index"
                           [checked]="isCertificateChecked(option)" (change)="toggleCertificate(option)">
                    <label class="form-check-label" [for]="'trade-cert-' + index">
                      <span class="cert-row"><span class="cert-key">มาตรฐาน</span><strong>{{ option.standardCode || '—' }}</strong></span>
                      <span class="cert-row"><span class="cert-key">ชื่อมาตรฐาน</span><strong>{{ option.standardName || '—' }}</strong></span>
                      <span class="cert-row"><span class="cert-key">เลขที่ใบรับรอง</span><strong>{{ option.certificateNo }}</strong></span>
                    </label>
                  </div>
                }
              </div>
              <small class="field-hint">ระบบจะจำใบรับรองที่เลือกไว้กับสินค้านี้ให้ครั้งถัดไป</small>
            }
          </div>
        }

        @if (isEdit() && (editKind() === 'PURCHASE' || editKind() === 'SHIPMENT')) {
          <div class="form-section">
            <div class="section-label">ข้อมูลขนส่ง</div>
            @if (!exporterOnlyRecord()) {
            <div class="harvest-box">
              <label class="harvest-input">
                <span class="ui-require">ทะเบียนรถ</span>
                <input id="trade-truck" type="text" class="form-control" [(ngModel)]="form.truckNo" name="truckNo"
                       [class.is-invalid]="submitted() && !form.truckNo.trim()">
              </label>
              <div class="driver-side-row">
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="trade-truck-buyer" name="truckSide"
                         value="BUYER" [(ngModel)]="form.truckSide">
                  <label class="form-check-label" for="trade-truck-buyer">รถของผู้ซื้อ</label>
                </div>
                <div class="form-check">
                  <input class="form-check-input" type="radio" id="trade-truck-seller" name="truckSide"
                         value="SELLER" [(ngModel)]="form.truckSide">
                  <label class="form-check-label" for="trade-truck-seller">รถของผู้ขาย</label>
                </div>
              </div>
              @if (submitted() && !form.truckNo.trim()) {
                <small class="invalid-feedback d-block text-danger">กรุณากรอกทะเบียนรถ</small>
              } @else if (submitted() && !form.truckSide) {
                <small class="invalid-feedback d-block text-danger">กรุณาระบุว่าเป็นรถของผู้ซื้อหรือผู้ขาย</small>
              }
            </div>
            }
            <div class="harvest-box">
              <label class="harvest-input">
                <span>เบอร์โทรคนขับ</span>
                <input id="trade-phone" type="tel" class="form-control"
                       [(ngModel)]="form.contactPhone" name="contactPhone">
              </label>
            </div>
          </div>
        }

        @if (isEdit() && isExportRecord()) {
          <div class="form-section">
            <div class="section-label">ข้อมูลส่งออก</div>
            <div class="harvest-box">
              <label class="harvest-input">
                <span class="ui-require">ด่านที่ส่งออก</span>
                <select id="trade-checkpoint" class="form-select"
                        [(ngModel)]="form.exportCheckpointId" name="exportCheckpointId">
                  <option value="">เลือกด่าน</option>
                  @for (checkpoint of checkpoints(); track checkpoint.id) {
                    <option [value]="checkpoint.id">{{ checkpoint.name }}</option>
                  }
                </select>
              </label>
            </div>
            <div class="harvest-box">
              <label class="harvest-input">
                <span class="ui-require">ทะเบียนผู้ส่งออก</span>
                <input id="trade-exporter-reg" type="text" class="form-control"
                       [(ngModel)]="form.exporterRegistrationNo" name="exporterRegistrationNo">
              </label>
            </div>
            <div class="harvest-box">
              <div class="form-check">
                <input id="trade-seller-location" type="checkbox" class="form-check-input"
                       [(ngModel)]="form.useSellerLocation" name="useSellerLocation">
                <label class="form-check-label" for="trade-seller-location">ใช้พิกัดภูมิศาสตร์ของผู้ขาย</label>
              </div>
              <div class="form-text">ปักหมุดรายการนี้ที่ตำแหน่งของผู้ขาย แทนตำแหน่งธุรกิจของคุณ</div>
            </div>
            @if (!exporterOnlyRecord()) {
            <div class="harvest-box">
              <div class="quantity-unit-row">
                <label class="harvest-input">
                  <span>เลขตู้</span>
                  <input id="trade-container" type="text" class="form-control"
                         [(ngModel)]="form.containerNo" name="containerNo">
                </label>
                <label class="harvest-input">
                  <span>ซีล</span>
                  <input id="trade-seal" type="text" class="form-control" [(ngModel)]="form.sealNo" name="sealNo">
                </label>
              </div>
            </div>
            <div class="harvest-box">
              <label class="harvest-input">
                <span>หมายเหตุคุณภาพ</span>
                <textarea id="trade-quality" class="form-control" rows="2"
                          [(ngModel)]="form.qualityNote" name="qualityNote"></textarea>
              </label>
            </div>
            }
          </div>
        }

        <div class="submit-row submit-actions">
          <button type="button" class="btn btn-primary flex-grow-1" [disabled]="saving()" (click)="submit()">
            @if (saving()) {
              <span class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
            }
            {{ isEdit() ? 'บันทึกการแก้ไข' : 'บันทึกการขาย' }}
          </button>
          <a class="btn btn-outline-secondary" [routerLink]="isEdit() ? ['/trade', recordId()] : ['/trade']">
            ยกเลิก
          </a>
        </div>
      </section>
    }
  }
</div>
